import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/per-tola";

export const Route = createFileRoute("/pakistan/per-tola")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `1 Tola Gold Price in Pakistan Today — Live 24K, 22K, 21K, 18K Per Tola Rate | Sona Ka Bhao`;
    const description = `Aaj Pakistan mein 1 tola sone ka rate live — gold per tola price in Pakistan for 24K, 22K, 21K, 18K across Karachi, Lahore, Islamabad, Rawalpindi sarafa bazaar. Refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "unit", unit: "per-tola" }}
      h1="1 Tola Gold Price in Pakistan Today — Live Rate"
      intro="Aaj Pakistan mein 1 tola (11.6638 gram) sone ka rate — 24K, 22K, 21K aur 18K har sarafa bazaar mein. Karachi reference se lekar Bahawalpur, Sukkur tak — live update every 10 minutes."
    />
  ),
});